<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">Submit Feedback</span>
      <button mat-icon-button (click)="cancel()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-16 m-12">

    <form [formGroup]="feedbackForm">
      <div class="feedback-title">
        <mat-form-field appearance="outline">
          <mat-label>Title</mat-label>
          <input matInput formControlName="title" required autocomplete="off" placeholder="Title">
          <mat-hint>A quick summary of the feedback given.</mat-hint>
        </mat-form-field>
      </div>

      <div class="feedback-type">
        <mat-form-field appearance="outline">
          <mat-label>Type</mat-label>
          <mat-select #select placeholder="Feedback Type" formControlName="type" required>
            <mat-option *ngFor="let type of feedbackTypes" [value]="type.name" matTooltip="{{type.desc}}"
                        matTooltipPosition="left">
              <span>
                <mat-icon [inline]="true" *ngIf="select.panelOpen">{{type.icon}}</mat-icon>
              </span>
              <span>
                {{type.name}}
              </span>
            </mat-option>
          </mat-select>
          <mat-hint>A generalized type of feedback.</mat-hint>
        </mat-form-field>
      </div>

      <div class="feedback-description" id="feedbackDescription">
          <editor (onInit)="onEditorInit()" class="feedback-description-editor" [apiKey]="tinyAPIKey" [init]="tinySettings" formControlName="description" (onChange)="descriptionChanged($event)">
          </editor>
        </div>
    </form>

  </div>

  <div mat-dialog-actions class="m-0 px-16 pb-16" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-stroked-button (click)="cancel()" color="warn" aria-label="CANCEL">
      Cancel
    </button>

    <button mat-button (click)="submit()" aria-label="Submit" color="accent" class="save-button mat-accent"
            [disabled]="formInvalid">
      Submit
    </button>

  </div>
</div>

<div class="loading-wrapper" *ngIf="isLoading|async">
  <mat-spinner diameter="20"></mat-spinner>
</div>
